/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import {
    AxisOptions
} from 'highcharts';
import GenericChartVisualization from './GenericChartVisualization';

function categoriesLabelGenerator(labels: string[]) {
    return labels.join('<br>');
}

export default class SpiderGenericChartVisualization extends GenericChartVisualization {

    getChartSection() {
        const chart = super.getChartSection();

        return {
            ...chart,
            polar: true
        };
    }

    getPlotOptionsSection() {
        const section = super.getPlotOptionsSection();
        return {
            ...section,
            series: {
                ...section.series,
                pointPlacement: 'on'
            }
        };
    }

    getTooltipSection() {
        const tooltip = super.getTooltipSection();

        tooltip.shared = true;

        return tooltip;
    }

    getXAxisSection(selectedRowIndex: number) {
        const xAxis = super.getXAxisSection(selectedRowIndex);

        return {
            ...xAxis,
            categories: this.getCategoriesFlat(selectedRowIndex, categoriesLabelGenerator),
            tickmarkPlacement: 'on',
            lineWidth: 0
        };
    }

    getYAxisSection(): AxisOptions {
        const yAxis: any = super.getYAxisSection();
        const { labels } = yAxis;

        if (labels.rotation > 0) {
            labels.x = -((labels.rotation / 90) * 10);
        }

        return {
            ...yAxis,
            labels,
            // this property used in highcharts-more.js
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            min: 0
        };
    }

    finalOptionAdjustment(options :any) {
        const newOptions :any = options;

        // this section must be here instead of 'getChartSection' because
        // chart section depends on xAxis section
        let categoryName = options.xAxis.categories[0];
        if (categoryName.name !== undefined) {
            categoryName = categoryName.name;
        }

        newOptions.chart.spacingTop = (categoryName.split('<br>').length - 1) * 1.8;
        newOptions.chart.spacingTop *= 8 * (1 + Math.abs(Math.sin(((options.xAxis.labels.rotation || 0) * Math.PI) / 180)));

        return super.finalOptionAdjustment(newOptions);
    }
}
